import React from 'react';
import { dressTypes } from '../data/mockData';

const DressTypes = () => {
  return (
    <section id="dress-types" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">Tipos de vestido</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {dressTypes.map((type) => (
            <div 
              key={type.id}
              className="group relative aspect-[3/4] overflow-hidden cursor-pointer bg-neutral-100 rounded-sm"
            >
              <img
                src={type.image}
                alt={type.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent group-hover:from-black/80 transition-all duration-500"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white text-lg font-light tracking-wide text-center">{type.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DressTypes;
